import { FEATURES, PRODUCT_FAMILY, PRODUCTS } from '@/base/constants/authorization'

export const accessKeywordInspectorPerformanceComparisonTabRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      $and: [
        { 'featureSet.type': { $eq: FEATURES.ACCESS_KEYWORD_INSPECTOR } },
        { 'featureSet.type': { $eq: FEATURES.ACCESS_PERFORMANCE_COMPARISON } },
      ],
    },
  ],
}

export const accessReviewsMostMentionedKeywordsTabRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      $and: [
        { 'featureSet.type': { $eq: FEATURES.ACCESS_REVIEW_ANALYSIS } },
        { 'featureSet.type': { $eq: FEATURES.ACCESS_SENTIMENT_ANALYSIS } },
      ],
    },
  ],
}

export const accessAsoReportAllRankedKeywordsTabRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      $and: [
        { 'featureSet.type': { $eq: FEATURES.ACCESS_ASO_REPORT } },
        { 'featureSet.type': { $eq: FEATURES.ACCESS_ALL_RANKED_KEYWORDS } },
      ],
    },
  ],
}

export const accessCompetitorKeywordsMultiComparisonTabRule = {
  $and: [
    { product: { $eq: PRODUCT_FAMILY.ASO } },
    {
      $or: [
        { name: { $eq: PRODUCTS.ASO_BASIC_V2 } },
        { name: { $eq: PRODUCTS.ASO_PRO } },
        { name: { $eq: PRODUCTS.ASO_BUSINESS } },
      ],
    },
    {
      featureSet: {
        $elemMatch: {
          type: { $eq: FEATURES.ACCESS_MULTI_COMPARISON },
        },
      },
    },
  ],
}
